// Import source styles
import '../scss/app.scss';

// Load External Libraries
import './bootstrap';
import AOS from 'aos';
import { Fancybox } from "@fancyapps/ui";

// Local imports
import { validate } from './modules/_validate.mjs';
import { mainMenu } from "./modules/_header.mjs";
import {homeIntroSlider} from "./modules/_home-intro.mjs";
import {slider} from "./modules/_slideshow.mjs";

document.addEventListener("DOMContentLoaded", () => {
    Fancybox.bind("[data-fancybox]");

    mainMenu();
    homeIntroSlider();
    slider();
    validate();
});
